export class Verzekering {
    contractnummer: string;
    polisnummer: string;
    sleutel: string;
    kenmerk_titel: string;
    kenmerken: string[];
}
